import { Injectable } from '@angular/core';
import { BaseService } from '../base/base.service';
import { ContentFactory } from '../../squidex';

@Injectable({ providedIn: 'root' })
export class UserService extends BaseService {
    constructor(contentFactory: ContentFactory) {
        super('users', contentFactory);
    }
}
